import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/request_log_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  target_id_eq: {
    model_name: 'RequestLog',
    column_type: 'string',
    column_name: 'targetId',
  },
  target_type_eq: {
    model_name: 'RequestLog',
    column_type: 'string',
    column_name: 'targetType',
  },
  title_cont: {
    model_name: 'RequestLog',
    column_type: 'string',
    column_name: 'title',
  },
  url_cont: {
    model_name: 'RequestLog',
    column_type: 'string',
    column_name: 'url',
  },
}
export const formColumnsConfig = {
  'self': {
    'target_id': { required: false, disabledUpdate: false },
    'target_type': { required: false, disabledUpdate: false },
    'title': { required: false, disabledUpdate: false },
    'url': { required: false, disabledUpdate: false },
    'params': { required: false, disabledUpdate: false },
    'response': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('RequestLog', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('RequestLog', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
